//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { CSSProperties, ReactNode } from 'react';
import { Fade } from '@mui/material';

type TabPanelProps = {
  children: ReactNode;
  index: number;
  value: number;
  className?: string;
  style?: CSSProperties;
};

const TabPanel = ({ children, value, index, className, style }: TabPanelProps) => (
  <Fade in={value === index} timeout={600}>
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} className={className} {...{ style }}>
      {children}
    </div>
  </Fade>
);

export default TabPanel;
